export default "version: 0.0.39\nbuild: 39\nenvironment: development\n"